import wrapComponents from "./wrap-components"

export default function tbComponentsPlugin() {

    return {
        wrapComponents
    }
}
